import React from 'react';
import {
    PageContainer,
    HeaderGridContainer,
    HeaderTextContainer,
    BodyGridContainer,
    BodyTextContainer,
    ContactTitle,
} from './UserAccess.styled';
import { getFormattedPhoneNumber } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';

const UserAccess = ({ userAccessDetails }) => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={12}
                    key="user"
                >
                    {t('accounts.userAccess.user')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={12}
                    key="role/accessType"
                >
                    {t('accounts.userAccess.myCaseAssignedRoleAccessType')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={12}
                    sm={2}
                    md={2}
                    lg={2}
                    xl={2}
                    mobile={12}
                    key="email"
                >
                    {t('accounts.userAccess.emailAddress')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={12}
                    key="contact"
                >
                    {t('accounts.userAccess.contactInfo')}
                </HeaderTextContainer>
            </HeaderGridContainer>
            <PageContainer>
                {userAccessDetails &&
                    userAccessDetails.map((user, index) => {
                        return (
                            <BodyGridContainer
                                container
                                // justifyContent={'space-between'}
                                direction="row"
                                key={index}
                            >
                                <BodyTextContainer
                                    item
                                    xs={12}
                                    sm={3}
                                    md={3}
                                    lg={3}
                                    xl={3}
                                    mobile={12}
                                    display
                                >
                                    <div className="userName">{user.name}</div>{' '}
                                    <div
                                        className="NetworkId"
                                        style={{
                                            margin:
                                                window.innerWidth <=
                                                sizes.mobileDevice
                                                    ? '0 0 0 6px'
                                                    : '0 0 8px 0',
                                        }}
                                    >
                                        {user.networkId}
                                    </div>
                                </BodyTextContainer>
                                <BodyTextContainer
                                    item
                                    xs={12}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                    mobile={12}
                                >
                                    {user.assignedRole &&
                                        user.assignedRole.map((role) => {
                                            return (
                                                <>
                                                    <div className="role">
                                                        {role}
                                                    </div>
                                                    <div
                                                        className="typeOfAccess"
                                                        style={{
                                                            margin:
                                                                window.innerWidth <=
                                                                sizes.mobileDevice
                                                                    ? ''
                                                                    : '0 0 8px 6px',
                                                        }}
                                                    >
                                                        {user.typeOfAccess}
                                                    </div>
                                                </>
                                            );
                                        })}
                                </BodyTextContainer>
                                <BodyTextContainer
                                    item
                                    xs={12}
                                    sm={2}
                                    md={2}
                                    lg={2}
                                    xl={2}
                                    mobile={12}
                                >
                                    <div className="userEmail">
                                        {user.email}
                                    </div>
                                </BodyTextContainer>
                                {user.workPhone ||
                                    user.cellPhone ||
                                    (user.fax && (
                                        <BodyTextContainer
                                            item
                                            xs={12}
                                            sm={3}
                                            md={3}
                                            lg={3}
                                            xl={3}
                                            mobile={12}
                                        >
                                            {/* <span
                                    style={{ color: '#140F4B', opacity: '0.6' }}
                                >
                                    {user.email}
                                </span> */}
                                            <br />
                                            {user.workPhone && (
                                                <>
                                                    <ContactTitle>
                                                        {' '}
                                                        {t(
                                                            'accounts.userAccess.workPhone'
                                                        )}{' '}
                                                    </ContactTitle>
                                                    {getFormattedPhoneNumber(
                                                        user.workPhone
                                                    )}
                                                </>
                                            )}
                                            <br />
                                            {user.cellPhone && (
                                                <>
                                                    <ContactTitle>
                                                        {' '}
                                                        {t(
                                                            'accounts.userAccess.cellPhone'
                                                        )}{' '}
                                                    </ContactTitle>
                                                    {getFormattedPhoneNumber(
                                                        user.cellPhone
                                                    )}
                                                </>
                                            )}
                                            <br />
                                            {user.fax && (
                                                <>
                                                    <ContactTitle>
                                                        {' '}
                                                        {t(
                                                            'accounts.userAccess.fax'
                                                        )}{' '}
                                                    </ContactTitle>
                                                    {user.fax}
                                                </>
                                            )}
                                            <br />
                                        </BodyTextContainer>
                                    ))}
                            </BodyGridContainer>
                        );
                    })}
            </PageContainer>
        </>
    );
};
export default UserAccess;
